import moment from 'moment-timezone';
import { displayTimeZone } from '../utils/date';

// Year suffixes (" '27" or '') for a tour's dates in order (start, ..., last), so a
// range names its year only where month and day alone would mislead: on a date whose
// next date falls in another year ("DEC 28 '26 – JAN 3 '27"), and on the last date
// when any of them is outside the current year ("NOV 17 – NOV 22 '27"). Ranges in
// the current year read as before. The current year is taken on the tour's clock.
export function yearSuffixes(dates, timeZone, now = moment()) {
    const thisYear = moment(now).tz(timeZone).year();
    const outsideThisYear = dates.some(d => d.year() !== thisYear);
    return dates.map((d, i) => {
        const next = dates[i + 1];
        const shown = next ? next.year() !== d.year() : outsideThisYear;
        return shown ? ` '${d.format('YY')}` : '';
    });
}

// A tour channel's date label, e.g. "NOV 17 – NOV 22", or just the date for a one-day
// tour. lastTs is the tour's last instant (callers pass end - 1ms so a midnight end
// shows the day before). Uppercase like the rest of the chat lists' date text.
export function tourDateRangeText(startTs, lastTs, timeZone, now = moment()) {
    // moment(undefined) is "now", which would pass for a real date.
    if (startTs == null || lastTs == null) {
        return null;
    }
    const zone = displayTimeZone(timeZone);
    const start = moment.utc(startTs).tz(zone);
    const last = moment.utc(lastTs).tz(zone);
    if (!start.isValid() || !last.isValid()) {
        return null;
    }
    if (start.isSame(last, 'day')) {
        const [year] = yearSuffixes([start], zone, now);
        return `${start.format('MMM D')}${year}`.toUpperCase();
    }
    const [startYear, lastYear] = yearSuffixes([start, last], zone, now);
    return `${start.format('MMM D')}${startYear} – ${last.format('MMM D')}${lastYear}`.toUpperCase();
}
